<template>
  <!-- Dùng trong h-checkboxGroup / a-checkbox-group -->
  <a-checkbox
    v-if="isGroupItem"
    :value="value"
    :disabled="disabled"
    :indeterminate="indeterminate"
  >
    <slot>{{ label }}</slot>
  </a-checkbox>

  <!-- Checkbox đơn (boolean) -->
  <a-checkbox
    v-else
    v-model:checked="innerValue"
    :disabled="disabled"
    :indeterminate="indeterminate"
    @change="onChange"
  >
    <slot>{{ label }}</slot>
  </a-checkbox>
</template>

<script lang="ts" setup>
import { computed } from "vue";

interface Props {
  modelValue?: boolean;
  /** Khi có value → dùng như option trong checkbox group */
  value?: string | number | boolean;
  label?: string;
  disabled?: boolean;
  indeterminate?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  value: undefined,
  label: "",
  disabled: false,
  indeterminate: false,
});

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
  (e: "change", value: boolean): void;
}>();

const isGroupItem = computed(() => props.value !== undefined);

const innerValue = computed({
  get: () => props.modelValue,
  set: (val: boolean) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onChange = (e: { target: { checked: boolean } }) => {
  emit("update:modelValue", e.target.checked);
  emit("change", e.target.checked);
};
</script>

<!--
  Hướng dẫn sử dụng — Checkbox
  Đơn: <h-checkbox v-model="agree">Đồng ý</h-checkbox>
  Trong group:
    <h-checkboxGroup v-model="list">
      <h-checkbox value="1">Email</h-checkbox>
    </h-checkboxGroup>
  Docs: src/components/ant/select/README.md
-->
